// extracted by mini-css-extract-plugin
module.exports = {"textWrapper":"TextInfoTooltip_textWrapper__1Nwf-","icon":"TextInfoTooltip_icon__1bCkB","tooltip":"TextInfoTooltip_tooltip__1cYEX"};